import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FamiliarComponent } from './familiar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { DocumentsUploaderModule } from '../../../_components/documents-uploader/documents-uploader.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

@NgModule({
  declarations: [
    FamiliarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    DocumentsUploaderModule,
    MatButtonModule,
  ],
})
export class FamiliarModule {
}
